export const Numeric = "Numeric";
export const AlphaText = "AlphaText";
export const AlphaNumeric = "AlphaNumeric";
export const EmailText = "EmailText";
